// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__2QDJq"};